const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogUsuario(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogUsuario`, params);
    },
    $obterRelatorioLogCSVUsuario(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeUsuarioCsv`, params);
    },
    $obterRelatorioLogPDFUsuario(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeUsuarioPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;